import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';
declare var Stimulsoft: any;

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {ToasterService} from "angular2-toaster";

import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {FormHelperService} from "../services/form-helper.service";
import {DataService} from "@cosbeni/database";
import {ConfirmComponent} from "../ui/modal";
import {StimulsoftFontService} from "../services/stimulsoft-font.service";

@Component({
    selector: 'cj-admin-report',
    templateUrl: 'report-management.component.html'
})

export class ReportManagementComponent implements OnInit {
    designer: any;
    designerOptions: any;
    viewer: any;
    viewerOptions: any;
    report: any;
    reports: any = [];
    name: string = "";
    mode: string = "viewer";
    private readonly: Boolean = true;
    @ViewChild('grid') grid: wjcGrid.FlexGrid;
    @ViewChild('removeReportPopup') removeReportPopup: ConfirmComponent;

    constructor(public dataService: DataService, public toasterService: ToasterService, public formHelper: FormHelperService, public formBuilder: FormBuilder, private stimulsoftFontService: StimulsoftFontService) {
    }

    ngOnInit() {
        // フォント/ローカライズは StimulsoftFontService が 1 回だけ非同期登録する (ira issue #151 と同対応)
        this.stimulsoftFontService.ensureLoaded();
        this.viewerOptions = new Stimulsoft.Viewer.StiViewerOptions();
        this.viewerOptions.appearance.scrollbarsMode = false;
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.viewer, 'StiViewer', false);
        this.designerOptions = new Stimulsoft.Designer.StiDesignerOptions();
        this.designerOptions.appearance.fullScreenMode = false;
        this.designerOptions.appearance.showSystemFonts = false;
        this.designer = new Stimulsoft.Designer.StiDesigner(this.designerOptions, 'StiDesigner', false);
        this.report = new Stimulsoft.Report.StiReport();
        this.loadReports();
    }

    loadReports(): void {
        this.dataService.query({
            sql: "SELECT FROM AP_Report ORDER BY name",
            count: "SELECT FROM AP_Report ORDER BY name",
            fetchPlan: "*:1",
        }, KaitoriyaConfig.SERVER_URL).subscribe(data => {
            this.reports = wjcCore.asArray(data.results);
            if(this.reports.length > 0){
                this.name = this.reports[0].name;
            }
        })
    }


    saveReport(): void {
        let json: any = {};
        json.name = this.name;
        if(this.mode == "viewer"){
            json.content = JSON.parse(this.viewer.report.saveToJsonString());
        } else {
            json.content = JSON.parse(this.designer.report.saveToJsonString());
        }
        json.content['@type'] = 'd'
        delete json.content.Styles;
        let sql = "BEGIN\n"
        for (let item of this.reports) {
            if (item.name == this.name) {
                json['@rid'] = item['@rid'];
            }
        }
        if (json.hasOwnProperty("@rid")) {
            sql = sql + "UPDATE AP_Report SET name = '" + this.name + "',content=" + JSON.stringify(json.content) + " WHERE name = '" + this.name + "'\n";
        } else {
            sql = sql + "INSERT INTO AP_Report SET name ='" + this.name + "',content=" + JSON.stringify(json.content) + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
            this.toasterService.pop('info', '保存', '保存されました。');
            this.loadReports();
        }, (error: any) => {
            this.toasterService.pop('error', '保存', '失敗しました。');
        })
    }

    async displayReport(): Promise<void> {
        await this.stimulsoftFontService.ensureLoaded();
        this.mode = "viewer";
        for (let item of this.reports) {
            if (item.name == this.name) {
                let r = {...item.content};
                delete r['@type'];
                delete r['@version'];
                this.report.load(r);
                document.getElementById("viewerContent").innerHTML = "";
                document.getElementById("designerContent").innerHTML = "";
                this.viewer.report = this.report;
                this.viewer.renderHtml("viewerContent");
            }
        }
    }

    async editReport(): Promise<void> {
        await this.stimulsoftFontService.ensureLoaded();
        this.mode= "designer";
        for (let item of this.reports) {
            if (item.name == this.name) {
                let r = {...item.content};
                delete r['@type'];
                delete r['@version'];
                this.report.load(r);
                document.getElementById("viewerContent").innerHTML = "";
                document.getElementById("designerContent").innerHTML = "";
                this.designer.report = this.report;
                this.designer.renderHtml('designerContent');
            }
        }
    }

    confirmRemoveReport(): void {
        this.removeReportPopup.modal.show();
    }

    removeReport(): void {
        for (let item of this.reports) {
            if (item.name == this.name) {
                let command = "DELETE VERTEX " + item['@rid'];
                this.dataService.command({sql: command}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
                        this.toasterService.pop('info', '削除', '削除されました。');
                        this.loadReports();
                    },
                    (error) => {
                        this.toasterService.pop('error', '削除', '失敗しました。');
                    })
            }
        }
    }
}

